import { useLingui } from '@lingui/react/macro';

import { DueAtType } from '@/components/DueAtType';
import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { useUpdateDraftRequest } from '@/models/request';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';
import { useDatabaseTranslation } from '@/services/i18n';

export const SelectDueAtType = () => {
  const { workflow, request } = useRequestContext();
  const { t } = useLingui();
  const { _db } = useDatabaseTranslation();
  const { mutate: updateDraftRequest } = useUpdateDraftRequest(request.id);
  const dueAtConfig = workflow?.config?.requestDueAt;

  const enabledDueAtConfig = dueAtConfig?.filter((dueAtOption) => dueAtOption.enabled);

  if (!enabledDueAtConfig) {
    return null;
  }

  return (
    <InputSelect
      variant="select"
      label={t({ id: 'requests.new.due-date.label', message: 'Due Date' })}
      isDisabled={enabledDueAtConfig.length === 1}
      isSearchable={false}
      value={enabledDueAtConfig.find((dueAtOption) => dueAtOption.type === request.dueAtType)}
      options={enabledDueAtConfig}
      getOptionValue={(dueAtOption) => dueAtOption.type}
      getOptionLabel={(dueAtOption) =>
        _db(
          dueAtOption.typeTranslation || {
            fr: dueAtOption.type,
            en: dueAtOption.type,
          }
        )
      }
      formatOptionLabel={(dueAtOption) => (
        <DueAtType
          translationType={
            dueAtOption.typeTranslation || {
              fr: dueAtOption.type,
              en: dueAtOption.type,
            }
          }
          days={dueAtOption.days}
        />
      )}
      hideSelectedOptions={false}
      onChange={(dueAtOption) => {
        if (dueAtOption) {
          updateDraftRequest({ dueAtType: dueAtOption.type });
        }
      }}
      size="medium"
      style={{ flex: 1 }}
    />
  );
};
